<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled
  flat

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    this.timeout = null;
    this.requestId = 0;
    this.isTornDown = false;

    GeocoderFactory().then(geocoder => {
      if (this.isTornDown) {
        return;
      }

      this.geocoder = geocoder;

      if (this.pendingQuery) {
        const q = this.pendingQuery;
        this.pendingQuery = null;
        this.querySelections(q);
      }
    });
  },

  beforeDestroy() {
    this.isTornDown = true;
    this.reset();
  },

  watch: {
    search(val) {
      if (!val || !String(val).trim()) {
        this.reset();
        this.items = [];
        return;
      }

      val !== this.select && this.querySelections(val) // eslint-disable-line
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    reset() {
      this.requestId++;

      if (this.timeout != null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.pendingQuery = null;

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.reset();

      if (!this.geocoder) {
        this.pendingQuery = value;
        return;
      }

      const id = this.requestId;
      this.loading = true;

      this.timeout = setTimeout(() => {
        this.timeout = null;

        this.geocoder.autocomplete(value).then(items => {
          if (id !== this.requestId || items === null) {
            return;
          }

          this.items = items.slice();
        }).catch(() => {
          if (id === this.requestId) {
            this.items = [];
          }
        }).finally(() => {
          if (id === this.requestId) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.reset();
      this.$emit("change", o);
    }
  }
};
</script>
